import cloneDeep from 'lodash/fp/cloneDeep';
import { setLocale } from 'yup';

import { yupLocale } from './yupLocale';

setLocale(cloneDeep(yupLocale));
